import authFr from "./authFr";
import commonFr from "./commonFr";
import footerFr from "./footerFr";
import galleryFr from "./galleryFr";
import menuFr from "./menuFr";
import navigationFr from "./navigationFr";
import orderFr from "./orderFr";
import paymentFr from "./paymentFr";
import statisticsFr from "./statisticsFr";

const mainFr = {
    common: commonFr,
    navigation: navigationFr,
    menu: menuFr,
    statistics: statisticsFr,
    order: orderFr,
    payment: paymentFr,
    auth: authFr,
    gallery: galleryFr,
    footer: footerFr,
};

export default mainFr;
